<script setup lang="ts">
import { useField } from 'vee-validate'
import { ref, useAttrs, watch } from 'vue'

import type { ImageObject } from '@/types/external/2work/doctypes/CustomDoctypes'

import { TEST_IDS_CREATE } from '@/_testIds/testIdsCreate'
import AvatarOrganization from '@/components/common/ui/avatar/AvatarOrganization.vue'
import ImageUpload from '@/components/common/ui/inputs/ImageUpload.vue'

interface SectionImageUploadProps {
  name: string
  aiImageUrl?: string | undefined
  labelText?: string
}

const props = defineProps<SectionImageUploadProps>()

const emit = defineEmits<(e: 'manual-input') => void>()

const attributesUse = useAttrs()

const { value } = useField<ImageObject>(() => {
  return props.name
})

const isAiUpdate = ref(false)

const handleInput = () => {
  if (isAiUpdate.value) {
    isAiUpdate.value = false
  } else {
    emit('manual-input')
  }
}

watch(
  () => props.aiImageUrl,
  (newVal) => {
    if (newVal) {
      isAiUpdate.value = true
    }
  },
)

watch(value, (val) => {
  console.debug('value', val)
})
</script>

<template>
  <ImageUpload
    v-model="value"
    :data-testid="attributesUse['data-testid'] ?? TEST_IDS_CREATE.sectionImageUpload.root"
    :label-text="labelText"
    @input="handleInput"
  >
    <AvatarOrganization :image="value?.content || aiImageUrl" size="huge" />
  </ImageUpload>
</template>
